module.exports = __webpack_public_path__ + "static/media/reward_head.4bfda4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reward_head.png
// module id = 2031
// module chunks = 6